import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  createCampaignService,
  getAllCampaignsService,
  getCampaignDetailService,
  getFreeSpinReportService,
  updateCampaignDetailsService,
  updateCampaignStatusService,
  revokeFreeSpinUserCampaignService,
  getCampaignPlayersService
} from 'network/services/promotions.service'

/**
 * Get All Campaigns Thunk
 */
export const fetchAllCampaigns = createAsyncThunk(
  'fetch/allCampaigns',
  async (data, thunkApi) => {
    try {
      const res = await getAllCampaignsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchFreeSpinUserReport = createAsyncThunk(
  'fetch/freeSpinUserReport',
  async (params, thunkApi) => {
    try {
      const res = await getFreeSpinReportService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

/**
 * Get Campaign Details Thunk
 */
export const fetchCampaignDetails = createAsyncThunk(
  'fetch/campaignDetail',
  async (campaignId, thunkApi) => {
    try {
      const res = await getCampaignDetailService(campaignId)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

/**
 * Create Campaign Thunk
 */
export const createCampaign = createAsyncThunk(
  'create/campaign',
  async ({ data, onSuccess }, thunkApi) => {
    try {
      const res = await createCampaignService(data)
      onSuccess(res.id)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

/**
 * Update Campaign Thunk
 */
export const updateCampaign = createAsyncThunk(
  'update/campaignDetail',
  async ({ data, onSuccess }, thunkApi) => {
    try {
      const res = await updateCampaignDetailsService(data)
      onSuccess()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

/**
 * Update Campaign Status Thunk
 */
export const updateCampaignStatus = createAsyncThunk(
  'update/campaignStatus',
  async ({ campaignId, status, closeDialog }, thunkApi) => {
    try {
      const res = await updateCampaignStatusService({ campaignId, status })
      closeDialog()
      return res
    } catch (error) {
      closeDialog()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

/**
 * Revoke Free Spin User Campaign Thunk
 */
export const revokeFreeSpinUserCampaign = createAsyncThunk(
  'freeSpin/revokeUserCampaign',
  async ({ data, onSuccess }, thunkApi) => {
    try {
      const res = await revokeFreeSpinUserCampaignService(data)
      onSuccess && onSuccess()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCampaignPlayers = createAsyncThunk(
  'fetch/freeSpinCampaignPlayers',
  async (params, thunkApi) => {
    try {
      const res = await getCampaignPlayersService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)